import { Injectable } from '@angular/core';
import { InterceptorSkipHeader } from 'app/auth/auth.interceptor';
import { API_ENDPOINTS } from 'app/core/constants/api-endpoints.constant';
import { ApiService } from 'app/shared/constant/api-service/api.service';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class Jc3Service {
    constructor(private _apiService: ApiService) {}

    private get headers() {
        return { headers: { [InterceptorSkipHeader]: InterceptorSkipHeader } };
    }

    getBanner(): Observable<any> {
        return this._apiService.get(API_ENDPOINTS.JC3.BANNER, this.headers);
    }

    getHomepage(): Observable<any> {
        return this._apiService.get(API_ENDPOINTS.JC3.HOMEPAGE, this.headers);
    }

    getSwitcher(): Observable<any> {
        return this._apiService.get(API_ENDPOINTS.JC3.SWITCHER, this.headers);
    }

    getWhatsNewdata(): Observable<any> {
        return this._apiService.get(API_ENDPOINTS.JC3.WHATS_NEW, this.headers);
    }

    getWhatIsEsg(): Observable<any> {
        return this._apiService.get(
            API_ENDPOINTS.JC3.WHAT_IS_ESG,
            this.headers
        );
    }

    getWhatIsEsgCards(): Observable<any> {
        return this._apiService.get(
            API_ENDPOINTS.JC3.WHAT_IS_ESG_CARDS,
            this.headers
        );
    }

    getWhyEsgMatters(): Observable<any> {
        return this._apiService.get(
            API_ENDPOINTS.JC3.WHY_ESG_MATTERS,
            this.headers
        );
    }

    getWhyEsgMattersCards(): Observable<any> {
        return this._apiService.get(
            API_ENDPOINTS.JC3.WHY_ESG_MATTERS_CARDS,
            this.headers
        );
    }

    getStartedEsgJc3(): Observable<any> {
        return this._apiService.get(
            API_ENDPOINTS.JC3.GET_STARTED_ESG_JC3,
            this.headers
        );
    }

    getStartedEsgJc3Cards(): Observable<any> {
        return this._apiService.get(
            API_ENDPOINTS.JC3.GET_STARTED_ESG_JC3_CARDS,
            this.headers
        );
    }

    getSmeSuccessStories(): Observable<any> {
        return this._apiService.get(
            API_ENDPOINTS.JC3.SME_SUCCESS_STORIES,
            this.headers
        );
    }

    getJumpstartOverviewSwitcher(): Observable<any> {
        return this._apiService.get(
            API_ENDPOINTS.JC3.JUMPSTART_OVERVIEW_SWITCHER,
            this.headers
        );
    }

    getJumpstartSteps(): Observable<any> {
        return this._apiService.get(
            API_ENDPOINTS.JC3.JUMPSTART_STEPS,
            this.headers
        );
    }

    getCapacityTitleSwitcher(): Observable<any> {
        return this._apiService.get(
            API_ENDPOINTS.JC3.CAPACITY_TITLE_SWITCHER,
            this.headers
        );
    }

    getCapacityCards(): Observable<any> {
        return this._apiService.get(
            API_ENDPOINTS.JC3.CAPACITY_CARDS,
            this.headers
        );
    }

    getCertificationTitleSwitcher(): Observable<any> {
        return this._apiService.get(
            API_ENDPOINTS.JC3.CERTIFICATION_TITLE_SWITCHER,
            this.headers
        );
    }

    getCertificationCards(): Observable<any> {
        return this._apiService.get(
            API_ENDPOINTS.JC3.CERTIFICATION_CARDS,
            this.headers
        );
    }

    getFinancialSolutionsTitleSwitcher(): Observable<any> {
        return this._apiService.get(
            API_ENDPOINTS.JC3.FINANCIAL_SOLUTIONS_TITLE_SWITCHER,
            this.headers
        );
    }

    getFinancialSolutionsCards(): Observable<any> {
        return this._apiService.get(
            API_ENDPOINTS.JC3.FINANCIAL_SOLUTIONS_CARDS,
            this.headers
        );
    }

    sendFeedback(data): Observable<any> {
        return this._apiService.post(`${API_ENDPOINTS.SEND_FEEDBACK}`, data);
    }

    getCertifications(): Observable<any> {
        return this._apiService.get(`${API_ENDPOINTS.CERTIFICATION}`, {
            headers: { [InterceptorSkipHeader]: InterceptorSkipHeader },
        });
    }

    getFinancingInfo(): Observable<any> {
        return this._apiService.get(`${API_ENDPOINTS.FINANCING}`, {
            headers: { [InterceptorSkipHeader]: InterceptorSkipHeader },
        });
    }

    // whatsNEw API
    getWhatsNew(): Observable<any> {
        return this._apiService.get(`${API_ENDPOINTS.WHATS_NEW}`, {
            headers: { [InterceptorSkipHeader]: InterceptorSkipHeader },
        });
    }

    // get SME Stories Header data API
    getSuccessConf(): Observable<any> {
        return this._apiService.get(`${API_ENDPOINTS.SUCCESS_CONF}`, {
            headers: { [InterceptorSkipHeader]: InterceptorSkipHeader },
        });
    }

    // get SME Stories data API
    getSuccessStories(): Observable<any> {
        return this._apiService.get(`${API_ENDPOINTS.SUCCESS_STORIES}`, {
            headers: { [InterceptorSkipHeader]: InterceptorSkipHeader },
        });
    }

    // get capacity build Tab Data
    getCapacity(): Observable<any> {
        return this._apiService.get(`${API_ENDPOINTS.CAPACITY}`, {
            headers: { [InterceptorSkipHeader]: InterceptorSkipHeader },
        });
    }
}
